import { IoCContainer, WebCoreIoCKeys, SettingsStorageBase, IWebsiteConstants, ApplicationTheme, ITranslation, IWebCoreSettings, SettingsBase, deepCopyClassName, SidebarManager, Sidebar, SidebarSide } from 'web-core-src';
import { News } from '../../../pocos/news.class';

export class WebCoreSettings extends SettingsBase implements IWebCoreSettings {
    constructor() {
        super();

        this.newsList = [];
        this.sidebarManager = new SidebarManager();
    }

    public applicationShortNameSnakeCase: string;
    public clientId: string;

    public developerCompanyDomain: string;
    public developerCompanyUrl: string;
    public applicationName: string;
    public applicationShortName: string;

    public get applicationShortNameWithVersion(): string {
        return this.applicationShortName + ' - ' + SettingsStorageBase.VERSION;
    }

    public extensionFeedbackMailTo: string;
    public developmentMailTo: string;
    public applicationFacebookGroupUrl: string;
    public applicationFacebookPageUrl: string;
    public developerPatreonUserName: string;
    public developerKofiUserName: string;
    public paypalHostedButtonId: string;

    public applicationTheme: string;

    public lastNewsFetchAt: Date = Date.settingInitialDate;

    @deepCopyClassName(News)
    public newsList: News[];

    @deepCopyClassName(SidebarManager)
    public sidebarManager: SidebarManager;

    public init() {}

    public setDefaultValues(): void {
        let websiteConstants: IWebsiteConstants = IoCContainer.get(WebCoreIoCKeys.IWebsiteConstants);
        this.developerCompanyDomain = websiteConstants.developerCompanyWebsite.MAIN_DOMAIN;
        this.developerCompanyUrl = websiteConstants.developerCompanyWebsite.FULL_MAIN_DOMAIN_URL;
        this.extensionFeedbackMailTo = 'extensions@' + this.developerCompanyDomain;
        this.developmentMailTo = 'development@' + this.developerCompanyDomain;
        this.applicationShortNameSnakeCase = websiteConstants.applicationWebsite.NAME_SNAKE_CASE;

        this.applicationTheme = ApplicationTheme.flatly;
        this.applicationName = '@applicationNameEn';
        this.applicationShortName = '@applicationShortNameEn';
        this.applicationFacebookGroupUrl = new URL('@applicationFacebookGroupUrlPart', websiteConstants.facebook.FULL_MAIN_DOMAIN_URL).toString();
        this.applicationFacebookPageUrl = new URL('@applicationFacebookPageUrlPart', websiteConstants.facebook.FULL_MAIN_DOMAIN_URL).toString();
        this.developerPatreonUserName = '@developerPatreonUserName';
        this.developerKofiUserName = '@developerKofiUserName';
        this.paypalHostedButtonId = '@paypalHostedButtonId';

        this.newsList = [];
        this.lastNewsFetchAt = new Date();

        this.sidebarManager = new SidebarManager();
        this.sidebarManager.add();
    }

    public translateDefaultValues(): void {
        let translation: ITranslation = IoCContainer.get(WebCoreIoCKeys.ITranslation);
        this.applicationName = translation.getMessage('app_name');
        this.applicationShortName = translation.getMessage('app_short_name');
    }
}
